import { VFile } from "./VFile";

export async function updateFile(file: VFile | null) {
  // TODO
  console.warn("updateFile is not implemented yet");
}
